import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '#api/axios';

type CreateEducationArgs = {
  name: string;
  institution?: string;
  startAt?: Date;
  gotAt?: Date;
  educationIssuerClassId?: string;
  description?: string;
};

export default function useCreateEducationMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (args: CreateEducationArgs) => {
      // API 호출
      const res = await request<string>({
        method: 'post',
        url: `/educations`,
        data: args
      });

      return res.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['educations']
      });
    }
  });
}
